export default __webpack_public_path__ + "static/media/services_dev_2.5aad05cd.jpg";